import React, { useRef, useState } from "react"
import { connect } from "react-redux"

import { DeleteOutlined } from "@ant-design/icons"
import { PlusOutlined, SyncOutlined } from "@ant-design/icons"
import { Form, Input } from "antd"
import Button from "components/atom/button"
import ImageLoad from "components/atom/image_load"
import { AppState } from "store"
import * as DocumentAction from "store/document/Action"

import "./styles.scss"

const FormImage: React.FC<any> = ({
  allowedExtensions = null,
  data,
  disabled = false,
  documentType = null,
  fileKey,
  name,
  onError,
  onLoadingEnd,
  onLoadingStart,
  onRemoved,
  onSuccess,
  position,
  remove,
  title = null,
  upload,
  url = null,
}) => {
  const fileInput: any = useRef(null)
  const document = data?.find((doc: any) => doc.fileKey === fileKey)
  const [uploadState, setUploadState] = useState<any>({
    error: null,
    fileKey: document?.fileKey,
    loading: null,
    position,
    success: null,
    url: document?.url || url,
  })

  const onHandleUpload = (e: any) => {
    if (uploadState.loading || disabled) {
      e.preventDefault()
    }

    fileInput.current.click()
  }

  const submitUpload = async () => {
    const { current } = fileInput

    if (current && current.files.length > 0) {
      const [file] = current.files
      onLoadingStart?.()
      setUploadState({ ...uploadState, error: null, loading: true })

      // Valida o tipo de arquivo a ser uploaded;
      if (allowedExtensions && !allowedExtensions.includes(file.type)) {
        onError?.()
        setUploadState({ ...uploadState, error: true, loading: false })
        return
      }

      const data = await upload({
        documentType,
        file,
        position,
        type: file.type,
      })

      onLoadingEnd?.()

      if (!data.hasError) {
        setUploadState({
          ...uploadState,
          fileKey: data.fileKey,
          loading: false,
          position,
          success: true,
          url: data.url,
        })
        onSuccess?.(data)
      } else {
        setUploadState({ ...uploadState, error: true, loading: false })
        onError?.(data)
      }
    }
  }

  const removeUpload = () => {
    remove({ fileKey: uploadState.fileKey })
    setUploadState({ loading: null, success: null, url: null })
    onRemoved()
  }

  return (
    <div>
      <Form.Item name={name}>
        <Input size="large" type="hidden" />
        <div className="molecule-form-image-content">
          {uploadState.success || uploadState?.url ? (
            <div>
              <ImageLoad
                ableToOpen={true}
                title={title}
                url={uploadState?.url}
              />
              <Button
                block
                className="_mt-4"
                icon={<DeleteOutlined />}
                onClick={() => removeUpload()}
                theme="outline-primary"
              >
                Remover
              </Button>
            </div>
          ) : (
            <div className="molecule-form-image-box-container">
              <div
                className={`molecule-form-image-box ${uploadState.error ? "border-red-500 border-2" : ""}`}
                onClick={onHandleUpload}
              >
                {uploadState?.loading ? (
                  <SyncOutlined spin />
                ) : (
                  <PlusOutlined className="molecule-form-image-box__icon" />
                )}
                <input
                  className="molecule-form-image-box__input-file"
                  onChange={submitUpload}
                  ref={fileInput}
                  type="file"
                />
              </div>
              {title && (
                <div className="_text-3 _font-weight-bold _mt-4 _text-center">
                  {" "}
                  {title}{" "}
                </div>
              )}
              {uploadState.error && (
                <div className="text-2 _mt-4 _text-center">
                  Não foi possível enviar a foto. Formato ou tamanho inválidos.
                </div>
              )}
            </div>
          )}
        </div>
      </Form.Item>
    </div>
  )
}

const mapStateToProps = ({ document }: AppState) => {
  return {
    data: document?.data,
    loading: document?.loading,
    success: document?.success,
  }
}

const mapDispatchToProps = {
  remove: DocumentAction.remove,
  upload: DocumentAction.upload,
}

// TODO: Remove redux;
export default connect(mapStateToProps, mapDispatchToProps)(FormImage) as any
